import React from 'react'

import styled from 'styled-components'

import {
  PrimaryButton,
  PrimaryButtonProps,
} from 'src/Components/Buttons/PrimaryButton'
import { MAX_MOBILE_WIDTH } from 'src/Styled/variables'

const StyledButton = styled(PrimaryButton)`
  height: 32px;
  padding: 8px 24px;
  align-items: center;
  flex-shrink: 0;
  border-radius: 8px;

  svg {
    path {
      transition: all 0.2s;
      fill: ${({ theme }) => theme.color.darkGrey};
    }
  }

  &:focus-visible {
    svg {
      path {
        fill: ${({ theme }) => theme.color.darkGreen};
      }
    }
  }

  @media (max-width: ${MAX_MOBILE_WIDTH}) {
    flex-grow: 1;
  }
`

const ChildrenWrapper = styled.div`
  flex-direction: row;
  align-items: center;
  justify-content: center;
  display: flex;
  gap: 8px;
`

export type SquareButtonProps = Omit<PrimaryButtonProps, 'ref'>

export const SquareButton: React.FC<SquareButtonProps> = ({
  loading,
  onClick,
  className,
  disabled,
  children,
  ...rest
}) => (
  <StyledButton
    loading={loading}
    disabled={disabled}
    onClick={onClick}
    className={className}
    {...rest}
  >
    <ChildrenWrapper>{children}</ChildrenWrapper>
  </StyledButton>
)
